/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-curly-brace-presence */

import React from 'react'
import { FaqContainer } from './styles'
import Accordion from './Accordion'

const collapsible = ({ content }) => {
  const fields = content?.data[0]?.attributes
  return (
    <FaqContainer id="Collapsible-group-ackodrive">
      <Accordion data={fields} />
    </FaqContainer>
  )
}

export default collapsible
